// eslint-disable-next-line no-unused-vars
export const subjectsAPIMap = {
  1: 'Geography',
  2: 'Mathematics',
  3: 'PrimaryEducation',
  4: 'SpeechTherapy',
  5: 'Physics',
  6: 'OtherLanguages',
  7: 'Lithuanian',
  8: 'InformationTechnologies',
  9: 'History',
  10: 'English',
  11: 'Biology',
  12: 'Chemistry',
  13: 'CarrierMentor',
  14: 'Romanian language',
};
